import { render, staticRenderFns } from "./EnergyIcon.vue?vue&type=template&id=06fb3f9b"
import script from "./EnergyIcon.vue?vue&type=script&lang=js"
export * from "./EnergyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports